import { Project } from "../types";

export const groupProjectsByCategories = (
  projects: Project[]
): Record<string, Project[]> => {
  const categorizedProjects: Record<string, Project[]> = {};

  projects.forEach((project) => {
    const categories = project.category.split(",").map((c) => c.trim());
    categories.forEach((category) => {
      if (!categorizedProjects[category]) {
        categorizedProjects[category] = [];
      }
      categorizedProjects[category].push(project);
    });
  });

  return categorizedProjects;
};

export const sortCategoriesByProjectCount = (
  categorizedProjects: Record<string, Project[]>
): [string, Project[]][] => {
  return Object.entries(categorizedProjects).sort(
    (a, b) => b[1].length - a[1].length
  );
};
